/* eslint-disable no-param-reassign */
import Moveable from 'moveable';

export default (sigArea) => {
  const canvas = sigArea.parentElement.querySelector('canvas');
  const frame = {
    translate: [0, 0],
  };

  return new Moveable(sigArea.parentElement, {
    target: sigArea,
    container: sigArea.parentElement,
    draggable: true,
    snappable: true,
    resizable: true,
    origin: false,
    bounds: {
      left: 0,
      top: 0,
      right: canvas.width,
      bottom: canvas.height,
    },
    padding: {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
    },
  })
    .on('dragStart', ({ set }) => {
      set(frame.translate);
    })
    .on('drag', ({ target, beforeTranslate }) => {
      frame.translate = beforeTranslate;
      target.style.transform = `translate(${beforeTranslate[0]}px, ${beforeTranslate[1]}px)`;
    })
    .on('resizeStart', ({
      target, set, dragStart,
    }) => {
      // If cssSize and offsetSize are different, set cssSize. (no box-sizing)
      const style = window.getComputedStyle(target);
      const cssWidth = parseFloat(style.width);
      const cssHeight = parseFloat(style.height);
      set([cssWidth, cssHeight]);
      if (dragStart) dragStart.set(frame.translate);
    })
    .on('resize', ({
      target, width, height, drag,
    }) => {
      frame.translate = drag.beforeTranslate;
      target.style
        .transform = `translate(${drag.beforeTranslate[0]}px, ${drag.beforeTranslate[1]}px)`;
      target.style.width = `${width}px`;
      target.style.height = `${height}px`;
    });
};
